import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const InformationCard = ({ counter, description }) => (
  <S.Card>
    <S.CardNumber>{counter}</S.CardNumber>
    <S.CardDescription>{description}</S.CardDescription>
  </S.Card>
);

export default InformationCard;

InformationCard.propTypes = {
  counter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  description: PropTypes.string.isRequired,
};
